import type { SubscribeToExtendedPage_extendedPage_definition as Definition } from "../../api/__generated__/SubscribeToExtendedPage";
import { shareRenderData } from "../../api/renderSharing";
import { syllableParity } from "./syllableParity";

type Rhese = {
  id: string;
  letters: { absoluteTextPosition: number; syllableId?: string | null }[];
};
export type RhesePresentation = {
  letterParity: (boolean | undefined)[];
  definitions: Definition[];
};

export function intersectsRhese(rhese: Rhese, definition: Definition) {
  const first = rhese.letters[0];
  const last = rhese.letters[rhese.letters.length - 1];
  const anchor = definition.anchors[0];
  // Converted letters are contiguous UTF-16 positions, including partial pages.
  return (
    !!first &&
    !!anchor &&
    anchor.utf16Size > 0 &&
    first.absoluteTextPosition < anchor.utf16Start + anchor.utf16Size &&
    last.absoluteTextPosition >= anchor.utf16Start
  );
}

/** One snapshot per mounted book renderer; no cross-book or unbounded cache. */
export function createRhesePresentations() {
  let previous = new Map<string, RhesePresentation>();
  return (rheses: Rhese[], definitions: Definition[], definitionMode: boolean) => {
    const parity = syllableParity(rheses);
    const next = new Map<string, RhesePresentation>();
    for (const rhese of rheses) {
      next.set(
        rhese.id,
        shareRenderData(previous.get(rhese.id), {
          letterParity: rhese.letters.map((letter) => parity.get(letter.absoluteTextPosition)),
          definitions: definitionMode
            ? definitions.filter((definition) => intersectsRhese(rhese, definition))
            : [],
        }),
      );
    }
    previous = next;
    return next;
  };
}
